import React from 'react'
import THREE from 'particlespace-graphics-engine'

import NavLink from '../../Routes/NavLink'

import { buildings } from '../../../core/controllers/Buildings'

import CanvasComponent from '../../Graphics/CanvasComponent.jsx'
import { buildingRenderer } from '../../../core/graphic_engine/controllers/building.js'

export default class Building extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            buildingID: props.data,
            updateCanvas: false,
            renderer: new THREE.CanvasRenderer(),
            canvasID: "building-card-holder"
        }

        this.didUpdateCanvas = false;
    }

    componentDidMount() {
        buildings.getBuilding(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.isMinimized != this.props.isMinimized) {
            if(!nextProps.isMinimized) {
                this.didUpdateCanvas = false;
            }
        }
    }

    componentDidUpdate() {
        if(!this.didUpdateCanvas) {
            this.didUpdateCanvas = true;
            const building = this.state.data;
            const buildingDetails = building.data;
            const buildingData = building.belongsTo;
            const buildingMetaData = building.meta_data;
            buildingRenderer.createMini3DBuildingModel(this, buildingMetaData.building_floor_plan_data.floor_plan_model, buildingData.building_level_total, buildingMetaData.level_states);
        }
    }

    render(){
        const building = this.state.data;
        const isMinimized = this.props.isMinimized;
        if(building == null) {
            return (
                <div></div>
            )
        } else if(!isMinimized) {
            const buildingDetails = building.data;
            const buildingData = building.belongsTo;
            const buildingMetaData = building.meta_data;

            return (
                <div class={"col-md-12"} key={buildingData.building_id}>
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                            <h4 class="title" onClick={this.props.minimizeTask}>{buildingDetails.building_name}</h4>
                            <p class="category">{buildingData.building_level_total} Floors</p>
                        </div>
                        <div class="content">
                            <NavLink to={"/building/" + buildingData.building_id}>
                                <CanvasComponent domID={this.state.canvasID} classID="ct-chart ct-perfect-fourth" renderer={this.state.renderer} updateCanvas={this.state.updateCanvas}/>
                                <div class="footer">
                                    <div class="legend">
                                        <i class="fa fa fa-cube text-info"></i> {buildingData.building_space_total} spaces&nbsp;&nbsp;
                                        <i class="fa fa-user-plus text-info"></i> {buildingData.building_availability_total} spaces available
                                    </div>
                                    <hr/>
                                    <div class="stats">
                                        <i class="fa fa-clock-o"></i> Last updated {buildingMetaData.formatted_update_time}
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            )
        } else {
            const buildingDetails = building.data;
            const buildingData = building.belongsTo;
            const buildingMetaData = building.meta_data;
            return (
                <div class="card">
                    <div class="header">
                        <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                        <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                        <h4 class="title" onClick={this.props.maximizeTask}>{buildingDetails.building_name}</h4>
                        <p class="category"></p>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/Type/Building.jsx